import React from 'react';
import classNames from 'classnames';
import { List, Map } from 'immutable';
import './style.scss';

import { Paragraph, View, ImageFromField } from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_WIDE,
  SCREEN_TABLET,
} from '../../../config/constants';

import {
  Container,
} from '../../../components';

const NodeFrontPage = ({ entity, className }) => {
  const hero = entity.getIn(['field_hero', 0]);
  const poster = hero.get('poster', '');
  const [videoIsLoaded, setVideoIsLoaded] = React.useState(false);
  const [videoCSS, setVideoCSS] = React.useState({
    display: 'none',
  });

  const classes = classNames(className, 'FrontPage', {
    'has-poster': hero.get('poster'),
  });

  React.useLayoutEffect(() => {
    function checkIsMobile() {
      const innerWidth = window.innerWidth;
      if (innerWidth < 768) {
        return true;
      }
      return false;
    }

    function updateSize() {
      const isMobile = checkIsMobile();

      if (!isMobile) {
        if (!videoIsLoaded) {
          setVideoIsLoaded(true);
        }

        return setVideoCSS({
          display: 'block',
        });
      }

      return setVideoCSS({
        display: 'none',
      });
    }

    window.addEventListener('resize', updateSize);

    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <article className={classes}>
      <div className="FrontPage--hero">
        { hero.get('bundle') === 'video_file' ? (
          <React.Fragment>
            { videoIsLoaded && (
              /* eslint-disable-next-line jsx-a11y/media-has-caption */
              <video style={videoCSS} autoPlay loop muted poster={poster}>
                <source src={hero.get('source')} type={hero.get('mimetype')} />
              </video>
            )}
            { poster && (
              <img className="poster" src={poster} alt={hero.get('title')} />
            )}
          </React.Fragment>
        ) : (
          <ImageFromField
            field={hero}
            imageStyles={Map({
              [SCREEN_MOBILE]: 'cropped_hero_small_small_viewport',
              [SCREEN_TABLET]: 'cropped_hero_medium_viewport',
              [SCREEN_NORMAL]: 'cropped_hero_medium_viewport',
              [SCREEN_WIDE]: 'crop_hero',
            })}
            lazyload
          />
        )}
      </div>
      <Container>
        <div className="u-indent u-margin--bottom--10">
          <div className="o-background--grey o-page-intro o-page-intro--with-hero">
            <h1 className="u-text-center">{entity.getIn(['title', 0, 'value'])}</h1>
            <h2 className="u-text-center">{entity.getIn(['field_subtitle', 0, 'value'])}</h2>
            <View id="vacancies" display="block_2" />
          </div>
        </div>

        {entity.get('field_paragraphs') ? (
          <div className="node--page--paragraphs-wrapper">
            {entity.get('field_paragraphs', List()).map((paragraph) => {
              const id = paragraph.get('target_id');
              const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
              return (
                <Paragraph
                  key={`paragraph:${id}:${language}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              );
            })}
          </div>
        ) : null}
      </Container>
    </article>
  );
};

export default NodeFrontPage;
